import React from 'react'

import { DashboardHeader,DashboardSideBar } from '../../components/dashboard/layout'
import {  ViewPleading } from '../../components/dashboard';
import { useStateContext } from '../../context/ContextProvider';
import { UserHeader, UserSidebare } from '../../components/UserDashboard/layout';
import UPleadingsDetails from '../../components/UserDashboard/UPleadingsDetails';
import UCaseDetails from '../../components/UserDashboard/UCaseDetails';
function UserCaseDetails() {
  const { activeMenu} = useStateContext()
  return (  <>

<div className="static lg:absolute  bg-main-bg dark:bg-main-dark-bg navbar w-full">
    <UserHeader /></div>
    <div className="flex justify-between w-full">
    {activeMenu ? (
        <div className="w-72 fixed sidebar dark:bg-back-darksecondary bg-back-primery ">
           <UserSidebare  />
        </div>
      ) : (
        <div className="w-0 =">
          <UserSidebare  />
        </div>
      )}   <div className={
        activeMenu
          ? 'dark:bg-back-darkprimery bg-back-secondary min-h-screen lg:ltr:ml-72 lg:rtl:mr-72  w-full  '
          : 'dark:bg-back-darkprimery bg-back-secondary  w-full min-h-screen  '
      }
    >

        <div className="w-full z-0 relative mt-20 justify-center flex">
            <UCaseDetails/>
        </div></div>
      </div>
</>

)

    

  

}



export default UserCaseDetails
